import { WifiStandardEnum } from '@ubnt/link-core/enums';
import { deviceNames, Device } from '@ubnt/link-core/modules/devices';


export const resolveMeshDevice = (wifiStandard: Device['wifiStandard']) => {
  if (wifiStandard === WifiStandardEnum.Wifi7) {
    return deviceNames.U7_Pro;
  }
  if (wifiStandard === WifiStandardEnum.Wifi6 || wifiStandard === WifiStandardEnum.Wifi6E) {
    return deviceNames.U6_Pro;
  }

  return deviceNames.UAP_AC_Pro;
};
